module.exports = __webpack_public_path__ + "static/media/icon-book.7b11c068.svg";